export const healthScore_v0 = [
  {
    breakerId: 'Airs',
    additionalData: {
      healthRemaining: 382459,
    },
    position: 0,
  },
  {
    breakerId: 'EvG',
    additionalData: {
      healthRemaining: 365100,
    },
    position: 1,
  },
  {
    breakerId: 'PRIMAPRIMAPRIMA',
    additionalData: {
      healthRemaining: 348367,
    },
    position: 2,
  },
  {
    breakerId: 'svinya123',
    additionalData: {
      healthRemaining: 338300,
    },
    position: 3,
  },
  {
    breakerId: 'KOLIMA',
    additionalData: {
      healthRemaining: 264151,
    },
    position: 4,
  },
  {
    breakerId: 'EKV59',
    additionalData: {
      healthRemaining: 238260,
    },
    position: 5,
  },
  {
    breakerId: 'BigPapa',
    additionalData: {
      healthRemaining: 219636,
    },
    position: 6,
  },
  {
    breakerId: 'Buterin',
    additionalData: {
      healthRemaining: 217100,
    },
    position: 7,
  },
  {
    breakerId: 'Pycuk',
    additionalData: {
      healthRemaining: 210100,
    },
    position: 8,
  },
  {
    breakerId: 'n0dding',
    additionalData: {
      healthRemaining: 126723,
    },
    position: 9,
  },
  {
    breakerId: 'The Miasma',
    additionalData: {
      healthRemaining: 116765,
    },
    position: 10,
  },
  {
    breakerId: 'DROBOSHENKO',
    additionalData: {
      healthRemaining: 66380,
    },
    position: 11,
  },
  {
    breakerId: 'Monro_',
    additionalData: {
      healthRemaining: 50589,
    },
    position: 12,
  },
  {
    breakerId: 'lkjzxsdgklhxb',
    additionalData: {
      healthRemaining: 8922,
    },
    position: 13,
  },
];
